module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['tools', _vm.typing && _vm.touchDevice ? 'is-typing' : ''],
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close()
      }
    }
  }, [_c('div', {
    ref: "posts",
    staticClass: "posts"
  }, [_c('div', {
    staticClass: "posts-inner"
  }, _vm._l((_vm.getComments(_vm.date)), function(post) {
    return _c('div', {
      staticClass: "post"
    }, [_c('div', {
      staticClass: "details"
    }, [_c('span', [_vm._v(_vm._s(post.user.name))]), _vm._v(" "), _c('time', {
      attrs: {
        "datetime": post.createdAt
      }
    }, [_vm._v(_vm._s(post.localized))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(post.message))])]), _vm._v(" "), (_vm.canDelete(post.user)) ? _c('icon', {
      attrs: {
        "name": "delete"
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteComment(post.id)
        }
      }
    }) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.message),
      expression: "message",
      modifiers: {
        "trim": true
      }
    }],
    ref: "message",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "focus": _vm.setFocus,
      "blur": [_vm.setBlur, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), (_vm.typing && _vm.touchDevice) ? _c('action', {
    staticClass: "cancel",
    attrs: {
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.message.blur()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.cancel')))]) : _vm._e(), _vm._v(" "), _c('action', {
    staticClass: "close",
    attrs: {
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.close')))]), _vm._v(" "), _c('action', {
    staticClass: "submit",
    attrs: {
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitMessage(_vm.date)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.add')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246ab638","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Chatbox.vue
// module id = 519
// module chunks = 225